export interface Article {
  id: string;
  title: string;
  slug: string;
  category: string;
  excerpt: string;
  content: string;
  coverImage: string;
  author: string;
  publishDate: string;
  tags: string[];
  isFeatured: boolean;
  isPinned: boolean;
}

export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  coverImage: string;
}

export interface Announcement {
  id: string;
  title: string;
  content: string;
  publishDate: string;
  isUrgent: boolean;
}

export interface MemberBenefit {
  id: string;
  title: string;
  description: string;
  icon: string;
  level: string;
}

export const categories: Category[] = [
  {
    slug: 'announcements',
    name: '官方公告',
    description: '琉璃神社最新官方公告、系统维护通知与重要声明',
    icon: 'ri-megaphone-line',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20temple%20shrine%20official%20notice%20board%20with%20warm%20lantern%20lighting%2C%20traditional%20wooden%20architecture%2C%20soft%20golden%20ambient%20light%2C%20elegant%20calligraphy%20atmosphere%2C%20serene%20and%20authoritative%20aesthetic%2C%20photorealistic%20style&width=1200&height=400&seq=cat-announcements&orientation=landscape'
  },
  {
    slug: 'resources',
    name: '资源下载',
    description: '正版授权素材、壁纸、音乐、字体等官方资源免费与付费下载',
    icon: 'ri-download-cloud-2-line',
    coverImage: 'https://readdy.ai/api/search-image?query=Digital%20art%20resource%20library%20with%20Japanese%20aesthetic%2C%20floating%20illustration%20panels%2C%20warm%20paper%20texture%20background%2C%20traditional%20ink%20painting%20elements%2C%20organized%20digital%20assets%20display%2C%20soft%20diffused%20lighting%2C%20elegant%20minimalist&width=1200&height=400&seq=cat-resources&orientation=landscape'
  },
  {
    slug: 'community',
    name: '社区动态',
    description: '创作者分享、粉丝作品展示、社区活动与互动讨论',
    icon: 'ri-group-line',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20festival%20community%20gathering%20with%20lanterns%20and%20cherry%20blossoms%2C%20warm%20evening%20atmosphere%2C%20people%20sharing%20art%20and%20creations%2C%20traditional%20market%20stalls%2C%20soft%20golden%20lighting%2C%20joyful%20and%20creative%20energy&width=1200&height=400&seq=cat-community&orientation=landscape'
  },
  {
    slug: 'tutorials',
    name: '创作教程',
    description: '绘画技巧、设计教程、创作心得，从入门到精通的系统学习资源',
    icon: 'ri-book-open-line',
    coverImage: 'https://readdy.ai/api/search-image?query=Traditional%20Japanese%20art%20studio%20with%20painting%20materials%2C%20ink%20brushes%20and%20rice%20paper%2C%20warm%20natural%20light%20from%20shoji%20screens%2C%20elegant%20workspace%2C%20artistic%20atmosphere%2C%20soft%20diffused%20daylight%2C%20serene%20creative%20environment&width=1200&height=400&seq=cat-tutorials&orientation=landscape'
  },
  {
    slug: 'membership',
    name: '会员专区',
    description: '琉璃神社会员专属福利、特权内容与限时活动',
    icon: 'ri-vip-crown-line',
    coverImage: 'https://readdy.ai/api/search-image?query=Luxurious%20Japanese%20temple%20interior%20with%20golden%20accents%2C%20exclusive%20VIP%20area%2C%20elegant%20tatami%20room%20with%20fine%20silk%20cushions%2C%20warm%20candlelight%2C%20refined%20and%20premium%20atmosphere%2C%20traditional%20yet%20opulent&width=1200&height=400&seq=cat-membership&orientation=landscape'
  },
];

export const articles: Article[] = [
  {
    id: '1',
    title: '琉璃神社2026年夏季大型更新公告',
    slug: '2026-summer-update',
    category: 'announcements',
    excerpt: '琉璃神社将于2026年8月15日进行年度最大规模的内容更新，新增"幻境回廊"创意工坊、"星月流光"会员体系等重磅功能。',
    content: `<p>亲爱的琉璃神社用户：</p><p>感谢大家一直以来对琉璃神社的支持与热爱。经过团队半年的精心筹备，我们很高兴地宣布，琉璃神社将于<strong>2026年8月15日</strong>进行年度最大规模的内容更新。</p><h3>一、全新「幻境回廊」创意工坊</h3><p>「幻境回廊」是一个面向所有创作者的开放式创意平台。在这里，你可以：</p><ul><li>发布原创插画、漫画、小说等作品</li><li>参与官方定期举办的创作大赛</li><li>与其他创作者交流技巧与心得</li><li>获得官方推荐与流量扶持</li></ul><p>每位创作者都将拥有专属的个人主页，展示作品集与创作历程。优质作品更有机会入选「琉璃精选」，获得全站推广资源。</p><h3>二、「星月流光」会员体系全面升级</h3><p>全新会员等级划分为：<strong>琉璃·初（免费）、琉璃·月（月费会员）、琉璃·星（年费会员）、琉璃·光（终身会员）</strong>四个等级。</p><p>各等级会员将享受不同程度的专属福利，包括：</p><ul><li>高清正版资源下载权限</li><li>创作工具高级功能解锁</li><li>线下活动优先参与权</li><li>官方周边商品折扣</li></ul><h3>三、技术架构全面优化</h3><p>本次更新还对底层技术架构进行了全面升级，页面加载速度提升40%，搜索体验大幅改善。同时新增暗色模式支持，保护您的视力。</p><p>更新期间（8月15日 00:00 - 06:00），网站将进行短暂维护，届时部分功能可能暂时不可用。给您带来的不便，敬请谅解。</p><p>琉璃神社团队<br>2026年8月8日</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Summer%20Japanese%20shrine%20with%20vibrant%20lanterns%20and%20festive%20decorations%2C%20warm%20golden%20sunset%20lighting%2C%20traditional%20wooden%20architecture%20with%20modern%20digital%20elements%2C%20cherry%20blossom%20petals%20floating%2C%20announcement%20celebration%20atmosphere%2C%20high%20detail&width=800&height=450&seq=article-1&orientation=landscape',
    author: '琉璃神社运营团队',
    publishDate: '2026-08-08',
    tags: ['更新公告', '幻境回廊', '会员体系'],
    isFeatured: true,
    isPinned: true,
  },
  {
    id: '2',
    title: '「琉璃画境」官方壁纸合集第三弹发布',
    slug: 'official-wallpaper-vol3',
    category: 'resources',
    excerpt: '全新「琉璃画境」系列壁纸正式上线，涵盖夏夜、神社、祭典三大主题，共48张高清壁纸，支持PC与移动端多种分辨率。',
    content: `<p>各位琉璃神社的伙伴们，久等了！</p><p>「琉璃画境」官方壁纸合集第三弹今天正式发布！本次壁纸合集以<strong>「夏日的记忆」</strong>为主题，由琉璃神社官方画师团队精心绘制。</p><h3>合集内容</h3><p>本次壁纸合集包含三大主题系列：</p><ul><li><strong>夏夜系列（16张）</strong>：以夏夜的琉璃神社为背景，萤火虫飞舞，星光点点，营造宁静梦幻的氛围</li><li><strong>神社系列（16张）</strong>：琉璃神社建筑细节与四季变化，展现神社的庄严与美丽</li><li><strong>祭典系列（16张）</strong>：热闹的夏日祭典场景，烟花、摊位、浴衣，充满欢乐与活力</li></ul><h3>规格说明</h3><p>所有壁纸均提供以下分辨率：</p><ul><li>PC端：2560×1440 (2K)、1920×1080 (Full HD)</li><li>移动端：1290×2796、1080×1920</li></ul><p>文件格式为PNG无损压缩，色彩空间sRGB，确保在不同设备上呈现最佳效果。</p><h3>获取方式</h3><p>免费用户可下载低分辨率预览版（720P），琉璃·月及以上会员可下载全部高清版本。前往资源下载页面即可获取。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Beautiful%20Japanese%20style%20digital%20wallpaper%20collection%20display%2C%20summer%20night%20shrine%20scenes%20with%20fireflies%2C%20traditional%20festival%20art%2C%20warm%20ambient%20lighting%2C%20artistic%20illustration%20style%2C%20elegant%20composition%2C%20rich%20colors&width=800&height=450&seq=article-2&orientation=landscape',
    author: '琉璃画师团队',
    publishDate: '2026-08-05',
    tags: ['壁纸', '资源下载', '琉璃画境'],
    isFeatured: true,
    isPinned: false,
  },
  {
    id: '3',
    title: '八月创作挑战赛：夏日幻境主题插画征集',
    slug: 'august-art-contest',
    category: 'community',
    excerpt: '琉璃神社八月创作挑战赛正式开启！以"夏日幻境"为主题，征集原创插画作品，总奖金池高达10万元，优秀作品将获得官方全平台推广。',
    content: `<p>创作的热情，在夏天燃烧！</p><p>琉璃神社八月创作挑战赛今日正式启动！无论你是专业画师还是业余爱好者，只要你有创作的热情，都欢迎参与。</p><h3>大赛主题：夏日幻境</h3><p>以"夏日幻境"为核心主题，发挥你的想象力，创作出属于你的夏日奇幻世界。可以是清凉的森林秘境、热闹的夏日祭典、静谧的夜空幻想……一切与夏日相关的奇幻想象皆可。</p><h3>参赛规则</h3><ul><li>作品形式：插画（数字绘画、手绘扫描均可）</li><li>作品数量：每位参赛者最多提交3幅作品</li><li>提交截止：2026年8月31日 23:59</li><li>结果公布：2026年9月10日</li></ul><h3>奖项设置</h3><ul><li><strong>琉璃大奖（1名）</strong>：奖金30,000元 + 琉璃·光终身会员 + 官方全平台推广</li><li><strong>金奖（2名）</strong>：奖金15,000元 + 琉璃·星年费会员</li><li><strong>银奖（5名）</strong>：奖金5,000元 + 琉璃·月月费会员</li><li><strong>人气奖（10名）</strong>：奖金1,000元 + 官方周边礼包</li></ul><p>快来「幻境回廊」创意工坊提交你的作品吧！</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Art%20contest%20promotion%20with%20Japanese%20summer%20fantasy%20theme%2C%20colorful%20illustrations%20floating%2C%20magical%20forest%20scene%20with%20glowing%20elements%2C%20warm%20golden%20and%20teal%20color%20palette%2C%20festive%20creative%20atmosphere%2C%20high%20detail%20digital%20art&width=800&height=450&seq=article-3&orientation=landscape',
    author: '琉璃神社活动组',
    publishDate: '2026-08-03',
    tags: ['创作挑战赛', '插画征集', '社区活动'],
    isFeatured: true,
    isPinned: false,
  },
  {
    id: '4',
    title: '从零开始学板绘：新手入门完全指南',
    slug: 'digital-art-beginner-guide',
    category: 'tutorials',
    excerpt: '面向完全零基础的绘画新手，从数位板选择、软件配置到线条练习与上色技巧，一步步带你走进板绘的世界。',
    content: `<p>想学板绘但不知从何入手？别担心，这篇指南就是为你准备的。</p><h3>第一步：选择你的数位板</h3><p>对于新手来说，不需要一开始就追求顶级设备。以下是一些入门推荐：</p><ul><li><strong>预算友好型（300-500元）</strong>：绘王H640P、Wacom CTL-472，画幅虽小但足够入门使用</li><li><strong>进阶型（800-1500元）</strong>：绘王Q630M、Wacom CTL-672，更大画幅带来更舒适的绘画体验</li><li><strong>一步到位型（2000元以上）</strong>：Wacom Intuos Pro系列，专业级性能</li></ul><p>个人建议新手从预算友好型开始，等确定自己真正热爱绘画后再升级设备。</p><h3>第二步：软件选择与配置</h3><ul><li><strong>Clip Studio Paint</strong>：漫画插画首选，功能全面，笔刷丰富</li><li><strong>Photoshop</strong>：行业标准，插件生态丰富，但学习曲线较陡</li><li><strong>Krita</strong>：免费开源，功能强大，是预算有限的最佳选择</li><li><strong>SAI2</strong>：轻量级，线条流畅，适合日系插画风格</li></ul><h3>第三步：基础练习</h3><p>不要着急画完整作品。先花1-2周时间练习基础：</p><ul><li>直线与曲线的控制练习</li><li>圆形、方形等基本图形的绘制</li><li>简单的透视练习（一点透视、两点透视）</li></ul><p>每天坚持30分钟，你会发现自己的线条控制力在稳步提升。</p><h3>第四步：从临摹开始</h3><p>选择你喜欢的画师作品进行临摹。临摹不是简单的复制，而是要理解原作的构图、用色和光影处理。建议从简单的角色立绘开始，逐步过渡到复杂的场景绘画。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Digital%20drawing%20tablet%20on%20wooden%20desk%20with%20Japanese%20art%20studio%20aesthetic%2C%20warm%20natural%20lighting%2C%20sketch%20paper%20and%20pens%20nearby%2C%20minimalist%20workspace%2C%20creative%20atmosphere%2C%20soft%20shadows%2C%20elegant%20composition&width=800&height=450&seq=article-4&orientation=landscape',
    author: '琉璃画师·墨染',
    publishDate: '2026-08-01',
    tags: ['板绘教程', '新手入门', '绘画基础'],
    isFeatured: false,
    isPinned: false,
  },
  {
    id: '5',
    title: '琉璃·星会员年度限定礼盒开箱',
    slug: 'star-member-giftbox',
    category: 'membership',
    excerpt: '琉璃·星年费会员专属年度限定礼盒正式发货！内含限定插画集、金属徽章、和风手账等精美周边，一起来开箱看看。',
    content: `<p>琉璃·星会员们，你们的年度限定礼盒已经陆续发货啦！让我们一起来看看今年的礼盒里都有什么惊喜吧。</p><h3>礼盒外观</h3><p>今年的礼盒采用了和风设计，深红色烫金工艺的盒面印有琉璃神社的标志性纹样，打开盒盖的瞬间便能闻到淡淡的樱花香气。盒子本身就是一个精美的收纳盒，可以用来存放绘画工具或小物件。</p><h3>礼盒内容一览</h3><ul><li><strong>《琉璃幻境》限定插画集</strong>：收录了12位官方签约画师的24幅原创插画，B5尺寸全彩印刷，纸张为日本进口哑粉纸，手感极佳</li><li><strong>琉璃神社金属徽章套装</strong>：包含神社鸟居、樱花、铃铛三枚徽章，锌合金材质，电镀工艺</li><li><strong>和风手账本</strong>：A5尺寸，布面硬壳，内页为方格与空白交替设计，适合绘画与笔记</li><li><strong>琉璃限定明信片（6张）</strong>：精选往期人气插画作品印制</li></ul><h3>获取条件</h3><p>本礼盒为琉璃·星年费会员专属福利，在2026年7月31日前开通或续费年费会员的用户均可获得。如果你还不是琉璃·星会员，现在加入即可获得下一期限定礼盒的获取资格。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Elegant%20Japanese%20style%20gift%20box%20unboxing%2C%20premium%20art%20book%20and%20metal%20badges%20displayed%20on%20tatami%20mat%2C%20warm%20soft%20lighting%2C%20traditional%20craftsmanship%20details%2C%20luxurious%20feel%2C%20red%20and%20gold%20accents&width=800&height=450&seq=article-5&orientation=landscape',
    author: '琉璃神社运营团队',
    publishDate: '2026-07-28',
    tags: ['会员福利', '限定周边', '开箱'],
    isFeatured: false,
    isPinned: false,
  },
  {
    id: '6',
    title: '关于近期第三方平台冒名侵权行为的严正声明',
    slug: 'copyright-infringement-statement',
    category: 'announcements',
    excerpt: '近期发现多个第三方平台冒用琉璃神社名义进行商业活动，我们在此严正声明并将依法追究侵权责任。',
    content: `<p>致广大用户与合作伙伴：</p><p>近期，我们注意到多个第三方电商平台及社交媒体账号在未经授权的情况下，冒用"琉璃神社"品牌名称、Logo及相关视觉元素进行商业活动，严重侵犯了琉璃神社的合法权益，也对广大用户的利益造成了潜在损害。</p><h3>侵权事实</h3><p>经调查，以下行为构成侵权：</p><ul><li>未经授权使用"琉璃神社"商标进行商品销售</li><li>仿冒琉璃神社官方账号发布虚假信息</li><li>未经许可转载、商用琉璃神社原创内容</li><li>以琉璃神社名义进行众筹或收费活动</li></ul><h3>我们的立场</h3><p>琉璃神社在此严正声明：</p><ol><li>琉璃神社目前仅通过官方网站（liulishenshe.com）及官方认证社交媒体账号发布信息</li><li>所有正版资源仅通过琉璃神社官方渠道提供下载</li><li>对于侵权行为，我们已委托律师事务所进行证据保全，并将依法追究侵权方的法律责任</li></ol><h3>用户提醒</h3><p>请广大用户提高警惕，认准琉璃神社官方渠道，避免因误入仿冒平台而造成经济损失。如发现可疑账号或平台，欢迎通过官方渠道举报。</p><p>琉璃神社始终坚持以用户利益为先，感谢大家的支持与信任。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Official%20statement%20document%20with%20traditional%20Japanese%20seal%20stamp%2C%20formal%20calligraphy%20style%2C%20warm%20paper%20texture%20background%2C%20red%20ink%20seal%2C%20authoritative%20and%20solemn%20atmosphere%2C%20elegant%20minimalist%20design&width=800&height=450&seq=article-6&orientation=landscape',
    author: '琉璃神社法务部',
    publishDate: '2026-07-25',
    tags: ['官方声明', '侵权公告', '版权保护'],
    isFeatured: false,
    isPinned: true,
  },
  {
    id: '7',
    title: '琉璃神社×知名画师合作系列第二弹公开',
    slug: 'collaboration-series-2',
    category: 'resources',
    excerpt: '琉璃神社与6位国内外知名画师的合作系列第二弹正式公开！涵盖角色设计、场景概念图等独家授权素材。',
    content: `<p>让大家期待已久的合作系列第二弹，终于来啦！</p><p>琉璃神社持续推动创作者生态建设，本次我们邀请了6位在国内外享有盛誉的画师，带来了风格各异的独家授权素材。</p><h3>合作画师阵容</h3><ul><li><strong>山田花子（日本）</strong>：以细腻和风插画著称，代表作《四季协奏曲》系列</li><li><strong>Luna Chen</strong>：北美新锐概念设计师，曾参与多款3A游戏项目</li><li><strong>墨染千秋</strong>：国内古风插画领军人物，作品风格华丽典雅</li><li><strong>星野琉璃</strong>：P站人气画师，以清新治愈的风格广受喜爱</li><li><strong>KAI</strong>：韩国角色设计师，擅长动态造型与色彩搭配</li><li><strong>风铃草</strong>：国内新生代插画师，作品充满想象力与故事感</li></ul><h3>授权内容</h3><p>每位画师提供5-10张独家授权素材，内容包括：角色立绘、场景概念图、道具设计稿、色彩设定表等。所有素材均获得商业授权，可用于个人创作参考与学习用途。</p><p>会员用户可前往资源下载页面获取。琉璃·星及以上会员享有优先下载权。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Collaborative%20art%20exhibition%20display%20with%20multiple%20illustration%20styles%2C%20Japanese%20anime%20aesthetic%2C%20diverse%20character%20designs%20on%20display%20panels%2C%20warm%20gallery%20lighting%2C%20professional%20art%20showcase%2C%20elegant%20arrangement&width=800&height=450&seq=article-7&orientation=landscape',
    author: '琉璃神社内容组',
    publishDate: '2026-07-20',
    tags: ['画师合作', '授权素材', '资源下载'],
    isFeatured: true,
    isPinned: false,
  },
  {
    id: '8',
    title: '色彩理论基础：理解色相、明度与饱和度',
    slug: 'color-theory-basics',
    category: 'tutorials',
    excerpt: '色彩是绘画的灵魂。本教程带你深入理解色相、明度、饱和度三大色彩属性，掌握配色技巧，让你的作品更有感染力。',
    content: `<p>色彩，是绘画中最具表现力的元素之一。理解色彩理论，是每一位画师的必修课。</p><h3>色相（Hue）</h3><p>色相是区分不同颜色的基本属性，如红、橙、黄、绿、蓝、紫。在色相环上，：</p><ul><li><strong>邻近色</strong>（30°以内）：和谐统一，适合营造柔和氛围</li><li><strong>对比色</strong>（120°-180°）：强烈对比，适合突出重点</li><li><strong>互补色</strong>（180°）：最大对比度，用得好很出彩，用不好会很刺眼</li></ul><h3>明度（Value）</h3><p>明度是色彩的明暗程度。即使是同一色相，不同明度也会带来完全不同的感受：</p><ul><li>高明度：轻盈、柔和、梦幻</li><li>中明度：稳定、自然、舒适</li><li>低明度：沉重、神秘、深沉</li></ul><p>专业建议：在绘画时，先用灰度（只关注明度）确定画面的明暗关系，再上色。这样画出来的作品结构更加扎实。</p><h3>饱和度（Saturation）</h3><p>饱和度是色彩的鲜艳程度。高饱和度色彩抢眼，低饱和度色彩内敛：</p><ul><li>高饱和度：活泼、热情、年轻</li><li>低饱和度：沉稳、高级、文艺</li></ul><p>一个小技巧：画面中大面积使用低饱和度色彩，小面积使用高饱和度色彩作为点缀，是营造高级感的常用手法。</p><h3>配色实践</h3><p>推荐一个简单的配色公式：<strong>主色70% + 辅色25% + 点缀色5%</strong>。这个比例几乎适用于所有类型的画面，从插画到UI设计都通用。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Color%20theory%20educational%20display%20with%20color%20wheel%20and%20paint%20swatches%2C%20Japanese%20art%20classroom%20setting%2C%20warm%20natural%20lighting%2C%20organized%20art%20supplies%2C%20elegant%20teaching%20atmosphere%2C%20soft%20shadows%2C%20clean%20composition&width=800&height=450&seq=article-8&orientation=landscape',
    author: '琉璃画师·星野',
    publishDate: '2026-07-15',
    tags: ['色彩理论', '绘画技巧', '配色教程'],
    isFeatured: false,
    isPinned: false,
  },
];

export const announcements: Announcement[] = [
  {
    id: 'a1',
    title: '2026年8月15日系统维护通知',
    content: '为配合年度大型更新，琉璃神社将于2026年8月15日 00:00 - 06:00 进行系统维护，届时部分功能可能暂时不可用。',
    publishDate: '2026-08-08',
    isUrgent: true,
  },
  {
    id: 'a2',
    title: '「幻境回廊」创意工坊即将上线',
    content: '全新创作者平台「幻境回廊」将于8月15日正式开放，欢迎所有创作者前来发布作品、参与活动。',
    publishDate: '2026-08-06',
    isUrgent: false,
  },
  {
    id: 'a3',
    title: '琉璃·星会员年度礼盒发货通知',
    content: '琉璃·星年费会员限定礼盒已于8月1日起陆续发货，预计7-15个工作日内送达，请留意物流信息。',
    publishDate: '2026-08-01',
    isUrgent: false,
  },
];

export const memberBenefits: MemberBenefit[] = [
  {
    id: 'b1',
    title: '高清资源下载',
    description: '免费下载全站高清壁纸、素材、字体等正版授权资源，月会员每月100次下载额度',
    icon: 'ri-download-2-line',
    level: '琉璃·月',
  },
  {
    id: 'b2',
    title: '创作工具特权',
    description: '解锁「幻境回廊」创意工坊高级功能，包括AI辅助上色、批量导出、云端协作等',
    icon: 'ri-brush-3-line',
    level: '琉璃·月',
  },
  {
    id: 'b3',
    title: '线下活动优先',
    description: '优先获得琉璃神社线下展览、签售会、创作者沙龙等活动的参与资格与折扣门票',
    icon: 'ri-calendar-event-line',
    level: '琉璃·星',
  },
  {
    id: 'b4',
    title: '限定周边礼盒',
    description: '年费会员每年获得官方限定周边礼盒，含插画集、徽章、手账本等专属好礼',
    icon: 'ri-gift-line',
    level: '琉璃·星',
  },
  {
    id: 'b5',
    title: '终身专属权益',
    description: '一次购买永久享受所有会员权益，含专属客服通道、年度限定礼盒、线下活动VIP席位',
    icon: 'ri-shining-line',
    level: '琉璃·光',
  },
  {
    id: 'b6',
    title: '创作者流量扶持',
    description: '会员作品优先获得官方推荐位与流量扶持，优质内容可获得全平台推广资源',
    icon: 'ri-rocket-line',
    level: '琉璃·星',
  },
];

export function getArticlesByCategory(categorySlug: string): Article[] {
  return articles.filter((a) => a.category === categorySlug);
}

export function getArticleById(id: string): Article | undefined {
  return articles.find((a) => a.id === id);
}

export function getFeaturedArticles(): Article[] {
  return articles.filter((a) => a.isFeatured);
}

export function getCategoryBySlug(slug: string): Category | undefined {
  return categories.find((c) => c.slug === slug);
}

export function getRelatedArticles(articleId: string, limit: number = 3): Article[] {
  const article = getArticleById(articleId);
  if (!article) return [];
  return articles
    .filter((a) => a.id !== articleId && a.category === article.category)
    .slice(0, limit);
}